import { Currency } from "@freightsimple/generated-dashboard-openapi-client/models/Currency";
import type { Invoice } from "@freightsimple/generated-dashboard-openapi-client/models/Invoice";
import type { Shipment } from "@freightsimple/generated-dashboard-openapi-client/models/Shipment";
import {
  formatIdentifierDateLine,
  getShipmentDisplayDetails,
  invoiceStatusDescription,
} from "@/Shared/Invoices/Helpers/invoiceUtils";

/**
 * Free-text filter for the Make Payments invoice table. Customers with many
 * unpaid invoices need to locate specific ones quickly (ENG-4367). Sorting is
 * the table's own column sorting, so only the filter lives here.
 */

function searchableText(
  invoice: Invoice,
  shipment: Shipment | undefined,
): string {
  const details = getShipmentDisplayDetails(shipment);
  const currencyText = invoice.currency === Currency.Cad ? "CAD" : "USD";

  return [
    invoice.invoiceIdentifier,
    formatIdentifierDateLine(invoice),
    invoice.amount.toFixed(2),
    currencyText,
    invoiceStatusDescription(invoice),
    details.pickupCity,
    details.deliveryCity,
    details.pickupBusinessName,
    details.deliveryBusinessName,
    details.pickupReferenceNumber,
    details.deliveryReferenceNumber,
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();
}

export function filterMakePaymentsInvoices(
  invoices: Invoice[],
  shipmentMap: Map<string, Shipment>,
  query: string | undefined,
): Invoice[] {
  const trimmed = query?.trim().toLowerCase();
  if (!trimmed) {
    return invoices;
  }

  return invoices.filter((invoice) =>
    searchableText(invoice, shipmentMap.get(invoice.shipmentId)).includes(
      trimmed,
    ),
  );
}
